<script>
  import theme from "../stores/theme";
  import { fly, slide, fade } from "svelte/transition";
  import app from "../stores/app";
  import * as ls from "local-storage";

  $: bg = $theme.mode == "dark" ? "bg-gray-800" : "bg-white";
  let menuVisible = false;
</script>

<header
  transition:fade={{ duration: 1000, delay: 2000 }}
  class="fixed left-0 top-0 w-full"
  style="z-index:999;"
>
  <div class="max-w-7xl mx-auto h-16 px-4 flex justify-between items-center">
    <div class={`flex items-center`}>
      <a href="#home" class="flex items-center">
        <span class="material-symbols-outlined" style="font-size: 2rem;">
          home
        </span>
      </a>
      <div class={`px-2 pt-2 ml-1 ${bg} rounded-md shadow-sm`}>
        {#if $app.lang === "en"}
          <button class="focus:outline-none" on:click={() => app.setLang("fr")}>
            <svg
              class="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 3 2"
            >
              <path fill="#ED2939" d="M0 0h3v2H0z" />
              <path fill="#fff" d="M0 0h2v2H0z" />
              <path fill="#002395" d="M0 0h1v2H0z" />
            </svg>
          </button>
        {:else}
          <button class="focus:outline-none" on:click={() => app.setLang("en")}>
            <svg
              class="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 60 30"
            >
              <clipPath id="a">
                <path d="M0 0v30h60V0z" />
              </clipPath>
              <clipPath id="b">
                <path d="M30 15h30v15zv15H0zH0V0zV0h30z" />
              </clipPath>
              <g clip-path="url(#a)">
                <path d="M0 0v30h60V0z" fill="#012169" />
                <path d="M0 0l60 30m0-30L0 30" stroke="#fff" stroke-width="6" />
                <path
                  d="M0 0l60 30m0-30L0 30"
                  clip-path="url(#b)"
                  stroke="#C8102E"
                  stroke-width="4"
                />
                <path d="M30 0v30M0 15h60" stroke="#fff" stroke-width="10" />
                <path d="M30 0v30M0 15h60" stroke="#C8102E" stroke-width="6" />
              </g>
            </svg>
          </button>
        {/if}
      </div>
    </div>
    <!-- Desktop Navigation -->
    <div
      class={`flex items-center ${bg} px-3 h-12 md:px-10 shadow-sm rounded-full`}
    >
      <a
        class="mr-5 hidden md:inline-block transition-colors duration-500
        hover:text-brand-red"
        href="#my-work"
      >
        {#if $app.lang === "en"}<span>My Work</span>
        {:else}<span>Mes Projects</span>{/if}
      </a>
      <a
        class="mr-5 hidden md:inline-block transition-colors duration-500
        hover:text-brand-red"
        href="#skills"
      >
        {#if $app.lang === "en"}<span>Skills</span>
        {:else}<span>Expertise</span>{/if}
      </a>
      <a
        class="mr-5 hidden md:inline-block transition-colors duration-500
        hover:text-brand-red"
        href="#contact"
      >
        {#if $app.lang === "en"}<span>Contact Me</span>
        {:else}<span>Me Contacter</span>{/if}
      </a>

      {#if $theme.mode == "dark"}
        <button
          class="focus:outline-none flex items-center"
          in:fade={{ duration: 1000 }}
          on:click={() => {
            theme.set({ mode: "light" });
            ls.set("mode", "light");
            const root = document.documentElement;
            root.style.setProperty("--thumbScroll", "#353d4a");
            document.body.style.backgroundColor = "#edf2f7";
            window.scrollBy({ top: 1, behavior: "smooth" });
          }}
        >
          <span class="material-symbols-outlined" style="font-size: 2rem;">
            light_mode
          </span>
        </button>
      {:else}
        <button
          class="focus:outline-none flex items-center"
          in:fade={{ duration: 1000 }}
          on:click={() => {
            theme.set({ mode: "dark" });
            ls.set("mode", "dark");
            const root = document.documentElement;
            root.style.setProperty("--thumbScroll", "#cbd5e0");
            document.body.style.backgroundColor = "#2d3748";
            window.scrollBy({ top: 1, behavior: "smooth" });
          }}
        >
          <span class="material-symbols-outlined" style="font-size: 2rem;">
            dark_mode
          </span>
        </button>
      {/if}
    </div>
  </div>
</header>

<!-- Mobile Naigation -->
<div
  transition:fly={{ x: 100, duration: 500, delay: 6000 }}
  class={`block md:hidden fixed right-0 bottom-0 px-4 pt-3 pb-2 mx-2 my-4 rounded-md shadow-lg ${bg}`}
  style="z-index:999;"
>
  <button
    class="focus:outline-none"
    on:click={() => {
      menuVisible = !menuVisible;
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="w-6 h-6 stroke-current"
      viewBox="0 0 30 21"
    >
      <g transform="translate(-3 -7.5)">
        <path class="abc" d="M4.5,18h27" />
        <path class="abc" d="M4.5,9h27" />
        <path class="abc" d="M4.5,27h27" />
      </g>
    </svg>
  </button>

  {#if menuVisible}
    <div
      transition:slide={{ duration: 100 }}
      class={`absolute mb-16 bottom-0 right-0 w-48 flex flex-col px-3 pt-4 pb-2 rounded-md shadow-lg ${bg} border-t-4 border-brand-green`}
    >
      <a
        class="mb-5 flex items-center"
        on:click={() => {
          menuVisible = false;
        }}
        href="#home"
      >
        <span class="material-symbols-outlined text-2xl mr-2"> home </span>
        {#if $app.lang === "en"}<span>Home</span>
        {:else}<span>Acceuil</span>{/if}
      </a>
      <a
        class="mb-5 flex items-center"
        on:click={() => {
          menuVisible = false;
        }}
        href="#my-work"
      >
        <span class="material-symbols-outlined text-2xl mr-2"> verified </span>

        {#if $app.lang === "en"}<span>My Work</span>
        {:else}<span>Mes Projects</span>{/if}
      </a>
      <a
        class="mb-5 flex items-center"
        on:click={() => {
          menuVisible = false;
        }}
        href="#skills"
      >
        <span class="material-symbols-outlined text-2xl mr-2"> handyman </span>
        {#if $app.lang === "en"}<span>Skills</span>
        {:else}<span>Expertise</span>{/if}
      </a>
      <a
        class="mb-5 flex items-center"
        on:click={() => {
          menuVisible = false;
        }}
        href="#contact"
      >
        <span class="material-symbols-outlined text-2xl mr-2">
          perm_phone_msg
        </span>
 {#if $app.lang === "en"}<span>Contact Me</span>
        {:else}<span>Me Contacter</span>{/if}
      </a>
    </div>
  {/if}
</div>

<style>
  .abc {
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 3px;
  }
</style>
